
export const API_URL='https://navigatorplus.sailink.id';
